<template>
  <div>
    <v-card color="Neutral" flat class="pdf-viewer-card overflow-y-auto">
      <v-card-text>
        <PDFViewer
          v-for="(file, index) in pdfListData"
          :key="index"
          :documentPath="file"
        />
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import widgetService from "../../api/widgetService";
import PDFViewer from "/src/components/dashboard/PDFViewer.vue";
export default {
  name: "PdfviewerWidget",
  props: ["widget"],
  components: {
    PDFViewer,
  },
  data() {
    return {
      parentHeight: 0,
      pdfList: [],
    };
  },
  computed: {
    fileList() {
      const tenant = sessionStorage.getItem("tenantId");
      const files = [];
      for (const file of this.widget.files) {
        const path = `${process.env.VUE_APP_CONFIG_SERVICE}widgets/${this.widget.id}&${file.fileId}?tenant=${tenant}`;
        files.push(path);
      }
      return files;
    },
    pdfListData() {
      return this.pdfList;
    },
  },
  async mounted() {
    await this.getWidgetFile();
    setTimeout(() => {
      const childCard = document.getElementsByClassName('pdf-viewer-card');
      if(childCard.length > 0) {
        for(let i = 0; i < childCard.length; i++) {
          this.parentHeight = childCard[i].parentElement.parentElement.parentElement.offsetHeight;
          if(childCard[i].parentElement.parentElement.children[0].childElementCount) {
            const height = childCard[i].parentElement.parentElement.children[0].offsetHeight;
            childCard[i].style.height = `${this.parentHeight - height}px`;
          }
        }
      }
    },500)    
  },
  methods: {
    async getWidgetFile() {
      try {
        const tenant = sessionStorage.getItem("tenantId");
        let pdfListItems = [];
        for (const file of this.widget.files) {
          const res = await widgetService.getWidgetFile(
            this.widget.id,
            file.fileId,
            tenant
          );
          pdfListItems.push(window.URL.createObjectURL(res));
        }
        this.pdfList = pdfListItems
      } catch (err) {
        //console.log(`Received response: ${err}`);       
        //this.$emit("alert", "Something Went Wrong, Please Try Again", 'error');
      }
      // const res = await this.downloadDocumentAPI(item.documentId);
    },
  },
};
</script>

<style>
</style>